export default "__VITE_ASSET__DUI46kRd__"